import { useMutation, useQuery } from '@tanstack/react-query'

import { HighlightsService } from '@/services/highlights.service'

import { toastError } from '@/utils/toastError'

export const useHighlightSharing = (token?: string) => {
	const {
		data: sharedFolders = [],
		isLoading: isSharedFoldersLoading,
		isError: isSharedFoldersError
	} = useQuery({
		queryKey: ['sharedHighlights', token],
		queryFn: () => HighlightsService.getSharedHighlights(token!),
		enabled: !!token,
		select: data => data.highlights
	})

	const taskId = sharedFolders[0]?.task_id

	const { mutateAsync: createShareLink, isLoading: isShareLinkCreating } =
		useMutation({
			mutationKey: ['createShareLink'],
			mutationFn: (highlightIds: number[]) =>
				HighlightsService.createShareLink({
					highlightIds,
					expiresInHours: 72,
					maxUses: 100
				}),
			onError: () => {
				toastError('Failed to create share link. Please try again.')
			}
		})

	const {
		mutateAsync: importSharedHighlights,
		isLoading: isImportSharedHighlightsLoading
	} = useMutation({
		mutationKey: ['importSharedHighlights'],
		mutationFn: ({ highlightIds }: { highlightIds?: number[] }) =>
			HighlightsService.importSharedHighlights({
				token: token!,
				highlightIds
			}),
		onError: () => {
			toastError('Failed to import shared folders. Please try again.')
		}
	})

	return {
		sharedFolders,
		taskId,
		isSharedFoldersLoading,
		isSharedFoldersError,
		createShareLink,
		isShareLinkCreating,
		importSharedHighlights,
		isImportSharedHighlightsLoading
	}
}
